export const partnerId = "modu";

// moduheyo: legacy | integrated
export const niceAuthMode: "legacy" | "integrated" = "integrated";
